<template lang="pug">
  b-modal(v-model="show" title="Editar plantilla" no-close-on-backdrop @hide="onHide")
    b-form-textarea(v-model="draft" :rows="8")
    div(slot="modal-footer")
      b-btn(variant="secondary" class="mr-2" @click="cancel") Cancelar
      b-btn(variant="primary" @click="save") Guardar
</template>

<script>
export default {
  name: 'template-modal-editor',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      draft: '',
      pendingSave: false,
    };
  },
  watch: {
    showDialog(newValue) {
      this.show = newValue;
      if (newValue) {
        this.draft = this.text;
      }
    },
  },
  methods: {
    blurActiveElement() {
      if (document && document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    },
    cancel() {
      this.pendingSave = false;
      this.blurActiveElement();
      this.show = false;
    },
    save() {
      this.pendingSave = true;
      this.blurActiveElement();
      this.show = false;
    },
    onHide() {
      if (this.pendingSave) {
        this.$emit('close', this.draft);
      } else {
        this.$emit('cancel');
      }
      this.pendingSave = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/TemplateModalEditor.vue